var _path, _path2, _path3, _path4, _path5, _g, _g2, _ellipse, _path6, _path7, _line, _line2, _line3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCervicalLateralFlexion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 141,
    viewBox: "0 0 157 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6875 89.6064C63.9396 89.7325 64.1287 89.7325 64.3178 90.0476C66.5237 93.5771 69.9902 95.0268 73.8348 95.9722C75.4105 96.3503 77.1752 96.7915 78.6879 96.6655C82.2804 96.3503 85.936 95.8461 89.1503 93.8292C90.789 92.8208 92.2387 91.5603 93.121 89.7325",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0234 77.502C89.7167 78.7625 89.1495 80.1491 89.5907 81.4726C90.1579 83.3634 90.4731 85.3803 91.2924 87.2081C91.9857 88.7838 93.4353 89.7922 94.7589 90.6746C99.1708 93.3847 104.024 95.0234 109.255 95.2755C114.423 95.5907 118.961 97.4815 122.932 100.948C125.705 103.343 127.155 106.494 128.856 109.583C131.188 113.931 130.558 118.532 130.306 123.07C130.117 125.97 129.55 128.806 129.802 131.705C130.054 134.415 130.432 137.188 130.999 139.899",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8086 77.502C67.1153 78.7625 67.6825 80.1491 67.2414 81.4726C66.6741 83.3634 66.359 85.3803 65.5396 87.2081C64.8463 88.7838 63.3967 89.7922 62.0731 90.6746C57.6613 93.3847 52.8082 95.0234 47.577 95.2755C42.4088 95.5907 37.8708 97.4815 33.9002 100.948C31.127 103.343 29.6774 106.494 27.9756 109.583C25.6436 113.931 26.2739 118.532 26.526 123.07C26.7151 125.97 27.2823 128.806 27.0302 131.705C26.7781 134.415 26.4 137.188 25.8327 139.899",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7695 77.5025C68.9619 78.0987 69.9913 79.1212 70.9998 79.6885C76.1049 82.4617 81.084 82.7768 86.0001 79.1843C87.3237 78.2389 88.7103 77.3565 89.9078 76.159C91.4835 74.6463 91.9877 72.6925 92.3028 70.6757C92.618 68.9739 92.8701 67.2722 93.1852 65.5705C95.3912 65.5075 96.5887 64.373 97.2189 62.3561C97.7862 60.3393 98.2904 58.4484 97.2189 56.4316C96.8408 55.6753 96.6517 54.982 95.3912 55.1711C94.5088 55.2971 94.6348 54.1626 94.6348 53.4693C94.7609 51.2004 95.2651 48.9314 95.076 46.6624C94.7609 43.6371 94.7609 40.4858 92.681 37.9017C90.9162 35.6958 88.7103 34.4352 85.8741 34.1201C82.7228 33.7419 79.5084 33.2377 76.357 33.4268",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6367 77.5025C87.4444 78.0987 86.0889 79.1212 85.0805 79.6885C79.9753 82.4617 74.9962 82.7768 70.0801 79.1843C68.7565 78.2389 67.3699 77.3565 66.1724 76.159C64.5967 74.6463 64.0925 72.6925 63.7774 70.6757C63.4623 68.9739 63.2101 67.2722 62.895 65.5705C60.6891 65.5075 59.4916 64.373 58.8613 62.3561C58.294 60.3393 57.7898 58.4484 58.8613 56.4316C59.2395 55.6753 59.4285 54.982 60.6891 55.1711C61.5714 55.2971 61.4454 54.1626 61.4454 53.4693C61.3193 51.2004 60.8151 48.9314 61.0042 46.6624C61.3193 43.6371 61.3193 40.4858 63.3992 37.9017C65.164 35.6958 67.3699 34.4352 70.2061 34.1201C73.3575 33.7419 76.5718 33.2377 79.7232 33.4268",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.6565 79.9377C100.391 81.0502 100.771 82.4505 101.361 83.4459C104.396 88.4001 108.55 91.1626 114.604 90.5094C116.223 90.3525 117.865 90.2816 119.501 89.8433C121.621 89.3212 123.035 87.8812 124.316 86.2921C125.44 84.9759 126.509 83.6283 127.633 82.3121C129.575 83.3605 131.179 82.9767 132.734 81.5452C134.233 80.0822 135.615 78.6968 135.696 76.4144C135.747 75.5704 135.929 74.8754 134.743 74.4089C133.916 74.0769 134.592 73.1574 134.939 72.557C136.183 70.655 137.754 68.9422 138.725 66.8826C139.964 64.1051 141.54 61.3759 141.031 58.0981C140.605 55.3053 139.325 53.1107 137.027 51.4197C134.487 49.5165 131.955 47.4727 129.131 46.0608",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.723 90.3713C116.392 90.2914 114.707 90.4992 113.55 90.4863C107.742 90.3353 103.273 88.1187 100.811 82.5494C100.138 81.0689 99.3783 79.6114 98.94 77.9756C98.3317 75.8778 98.872 73.9336 99.6075 72.0294C100.185 70.3981 100.818 68.7983 101.396 67.167C99.517 66.0094 99.0472 64.4282 99.5098 62.3664C100.027 60.3361 100.536 58.4465 102.472 57.2356C103.178 56.7697 103.688 56.2638 104.685 57.0578C105.386 57.6082 105.844 56.5627 106.191 55.9623C107.216 53.9343 107.914 51.7172 109.212 49.8467C110.998 47.3843 112.574 44.6552 115.667 43.4572C118.298 42.4292 120.839 42.4405 123.453 43.5857C126.371 44.8339 129.407 46.0044 132.041 47.7438",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8748 79.9377C53.1403 81.0502 52.76 82.4505 52.1703 83.4459C49.1357 88.4001 44.9812 91.1626 38.9275 90.5094C37.3086 90.3525 35.6665 90.2816 34.0307 89.8433C31.9098 89.3212 30.4962 87.8812 29.2149 86.2921C28.0911 84.9759 27.0219 83.6283 25.8981 82.3121C23.9562 83.3605 22.3519 82.9767 20.7977 81.5452C19.298 80.0822 17.9159 78.6968 17.8354 76.4144C17.7847 75.5704 17.6018 74.8754 18.788 74.4089C19.6152 74.0769 18.9388 73.1574 18.5922 72.557C17.3485 70.655 15.7774 68.9422 14.8066 66.8826C13.5669 64.1051 11.9912 61.3759 12.5004 58.0981C12.9258 55.3053 14.2059 53.1107 16.5046 51.4197C19.0446 49.5165 21.5763 47.4727 24.3999 46.0608",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8084 90.3713C37.1391 90.2914 38.8242 90.4992 39.9812 90.4863C45.789 90.3353 50.2586 88.1187 52.7198 82.5494C53.3933 81.0689 54.153 79.6114 54.5913 77.9756C55.1995 75.8778 54.6593 73.9336 53.9238 72.0294C53.3458 70.3981 52.7133 68.7983 52.1353 67.167C54.0142 66.0094 54.4841 64.4282 54.0215 62.3664C53.5043 60.3361 52.9955 58.4465 51.0592 57.2356C50.3535 56.7697 49.8431 56.2638 48.846 57.0578C48.1449 57.6082 47.6868 56.5627 47.3402 55.9623C46.3149 53.9343 45.617 51.7172 44.3188 49.8467C42.5332 47.3843 40.9576 44.6552 37.8643 43.4572C35.233 42.4292 32.6923 42.4405 30.0785 43.5857C27.1603 44.8339 24.1245 46.0044 21.4899 47.7438",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.5024,
    cy: 69.1558,
    rx: 77.5024,
    ry: 44.1168,
    stroke: "url(#paint0_linear_916_38766)",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3487 16.2504C75.7927 16.2504 74.5586 15.6602 73.6822 14.4619C72.788 13.2815 72.3409 11.7076 72.3409 9.74019C72.3409 7.77282 72.788 6.19892 73.6822 5.00062C74.5586 3.82019 75.7927 3.22998 77.3487 3.22998C78.9226 3.22998 80.1567 3.82019 81.0331 5.00062C81.9094 6.19892 82.3566 7.77282 82.3566 9.74019C82.3566 11.7076 81.9094 13.2815 81.0331 14.4619C80.1567 15.6602 78.9226 16.2504 77.3487 16.2504ZM75.4529 12.7807C75.8821 13.4782 76.5081 13.8359 77.3487 13.8359C78.1893 13.8359 78.8153 13.4782 79.2624 12.7807C79.6917 12.0831 79.9063 11.0637 79.9063 9.74019C79.9063 8.3988 79.6917 7.37934 79.2624 6.68182C78.8153 5.9843 78.1893 5.6266 77.3487 5.6266C76.5081 5.6266 75.8821 5.9843 75.4529 6.68182C75.0236 7.37934 74.809 8.3988 74.809 9.74019C74.809 11.0816 75.0236 12.0831 75.4529 12.7807Z",
    fill: "#2E4C8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7738 6.09225C85.2006 6.09225 84.7459 5.8748 84.423 5.43332C84.0936 4.99843 83.9288 4.41857 83.9288 3.69375C83.9288 2.96893 84.0936 2.38908 84.423 1.9476C84.7459 1.5127 85.2006 1.29526 85.7738 1.29526C86.3537 1.29526 86.8083 1.5127 87.1312 1.9476C87.4541 2.38908 87.6188 2.96893 87.6188 3.69375C87.6188 4.41857 87.4541 4.99843 87.1312 5.43332C86.8083 5.8748 86.3537 6.09225 85.7738 6.09225ZM85.0754 4.81393C85.2335 5.07091 85.4641 5.2027 85.7738 5.2027C86.0835 5.2027 86.3141 5.07091 86.4789 4.81393C86.637 4.55695 86.7161 4.18136 86.7161 3.69375C86.7161 3.19956 86.637 2.82397 86.4789 2.56699C86.3141 2.31001 86.0835 2.17822 85.7738 2.17822C85.4641 2.17822 85.2335 2.31001 85.0754 2.56699C84.9172 2.82397 84.8381 3.19956 84.8381 3.69375C84.8381 4.18795 84.9172 4.55695 85.0754 4.81393Z",
    fill: "#2E4C8B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77.8728,
    y1: 24.4109,
    x2: 77.8728,
    y2: 136.555,
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.26 2.26"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.0402,
    y1: 40.7465,
    x2: 78.1124,
    y2: 137.866,
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.26 2.26"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.564178,
    y1: -0.564178,
    x2: 112.709,
    y2: -0.564178,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 133.949 40.54)",
    stroke: "#2B4B8E",
    strokeWidth: 1.12836,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.26 2.26"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_38766",
    x1: 78.5024,
    y1: 25.0391,
    x2: 78.5024,
    y2: 53.0592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4B8E",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCervicalLateralFlexion);
export default __webpack_public_path__ + "static/media/ic-cervical-lateral-flexion.9d3621b70955ea9848ce449db67b3784.svg";
export { ForwardRef as ReactComponent };